import { PlusIcon } from '@heroicons/react/20/solid'

const BudgetPlanner = () => {

    return(
        <>
            <div className="p-2 lg:px-2 overflow-hidden">
                <div className="lg:mx-0 lg:max-w-none overflow-hidden">
                    <div className="relative">
                        <div className="absolute inset-0 flex items-center" aria-hidden="true">
                            <div className="w-full border-t border-gray-300" />
                        </div>
                        <div className="relative flex items-center justify-between">
                            <span className="bg-white pr-3 text-2xl font-semibold tracking-tight text-neutral-600">Budget</span>
                            <button
                            type="button"
                            className="inline-flex items-center gap-x-1.5 rounded-full bg-white px-3 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            >
                            <PlusIcon className="-ml-1 -mr-0.5 h-5 w-5 text-gray-400" aria-hidden="true" />
                            <span>Add New</span>
                            </button>
                        </div>
                    </div>
                    <div className="mt-5 grid max-w-xl text-sm md:text-base text-justify grid-cols-1 gap-5 leading-7 text-gray-700 lg:max-w-none ">
                    
                    
                    </div>
                </div>
            </div>
        </>
    )

}

export default BudgetPlanner;